import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Pipe({
  name: 'getAge'
})
export class GetAgePipe implements PipeTransform {
  constructor(private commonService: CommonService) {}
  transform(dob: any): any {
    return this.commonService.calculateAge(dob);
  }

}
